import posthog from "posthog-js";
export default {
  install(app) {
      if(import.meta.env.VITE_POSTHOG_TOKEN) {
          app.config.globalProperties.$posthog = posthog.init(
              import.meta.env.VITE_POSTHOG_TOKEN,
              {
                  api_host: 'https://eu.i.posthog.com',
                  person_profiles: 'identified_only'
              }
          );
      }
  },
};
